import { createAction, props } from '@ngrx/store';
import {MEALS_SET_COURSES, MEALS_SET_CATEGORIES} from "./action-types";
import {Course, PostCategory} from "../../types";

export const setCategories = createAction(MEALS_SET_CATEGORIES, props<{ categories: PostCategory[] }>());
export const setCourses = createAction(MEALS_SET_COURSES, props<{ courses: Course[] }>());
